import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock, Loader2, XCircle } from "lucide-react";
import { api, errMsg, fmtDateTime, money } from "@/lib/api";

export default function Success() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  const [s, setS] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!ref) { setError("Missing payment reference."); return undefined; }
    let stop = false;
    const load = async () => {
      try { const { data } = await api.get(`/public/sales/${encodeURIComponent(ref)}`); if (!stop) setS(data); return data.status; }
      catch (e) { if (!stop) setError(errMsg(e)); return "ERR"; }
    };
    load();
    const t = setInterval(async () => { const st = await load(); if (st !== "PENDING") clearInterval(t); }, 4000);
    return () => { stop = true; clearInterval(t); };
  }, [ref]);
  const paid = s?.status === "PAID";
  const pending = s?.status === "PENDING";
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-violet-50 to-blue-50 p-6">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 text-center shadow-xl" data-testid="success-page">
        <img src="/logo-full.png" alt="GIA care+" className="mx-auto w-40" />
        {error ? <p className="mt-6 text-sm text-red-600" data-testid="success-error">{error}</p> : !s ? <Loader2 className="mx-auto mt-8 animate-spin text-purple-600" /> : (
          <div className="mt-6 space-y-3">
            {paid ? <CheckCircle2 size={48} className="mx-auto text-emerald-500" /> : pending ? <Clock size={48} className="mx-auto text-amber-500" /> : <XCircle size={48} className="mx-auto text-slate-400" />}
            <h1 className="text-2xl font-extrabold" data-testid="success-title">{paid ? "Payment confirmed" : pending ? "Payment received – confirming…" : "Payment not completed"}</h1>
            <p className="text-sm text-slate-500" data-testid="success-status">
              {paid ? "PayMongo verified your payment and your GIAcare+ card is now active." : pending ? "We're waiting for PayMongo to verify your payment. This page updates automatically." : `Status: ${s.status.toLowerCase()}. No membership was activated.`}
            </p>
            <div className="rounded-2xl bg-slate-50 p-4 text-left text-sm">
              <p className="flex justify-between"><span className="text-slate-500">Package</span><b>{s.package_name}</b></p>
              <p className="flex justify-between"><span className="text-slate-500">Amount</span><b>{money(s.amount, s.currency)}</b></p>
              <p className="flex justify-between"><span className="text-slate-500">Card</span><b className="font-mono">{s.card_serial}</b></p>
              {s.receipt_number && <p className="flex justify-between"><span className="text-slate-500">Receipt</span><b className="font-mono" data-testid="success-receipt">{s.receipt_number}</b></p>}
              {s.paid_at && <p className="flex justify-between"><span className="text-slate-500">Paid</span><b>{fmtDateTime(s.paid_at)}</b></p>}
            </div>
            {paid && <Link to="/register" className="btn-primary w-full py-3" data-testid="success-register-link">Register your card</Link>}
          </div>
        )}
      </div>
    </div>
  );
}
